/**
 * 配車計画 ドライバー配車 運搬統合
 */
 import Vue from 'vue'
 import * as httpConst from '../../../../../constants/httpConst'

 const API_PATH = `${httpConst.DRIVER_ENDPOINT}/allocate/entries/switch_drivers`

 const allocate_entry_switch_driver = {
  namespaced: true,
  state: {},
  getters: {},
  actions: {
    update({ commit }, { params }) {
      return new Promise( ( resolve ) => {
        Vue.$http.put(API_PATH, params).then( data => {
          let content = data.content
          commit('snackbar/showInfo', { message: '変更しました' }, { root: true })
          resolve(content)
        } )
      })
    },
  },
  mutations: {},

 }

 export default allocate_entry_switch_driver
